import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem, Divider, CircularProgress, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, DialogActions, } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DataTable from "../components/DataTable";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import SnackbarAlert from "../components/SnackbarAlert";
export default function PurchaseEntry() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [search, setSearch] = useState("");
    const [productCategory, setProductCategory] = useState([]);
    const [productList, setProductList] = useState({});
    const [editState, setEditState] = useState(null);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);
    const [purchaseId, setPurchaseId] = useState("");
    const [purchaseDate, setPurchaseDate] = useState(new Date().toISOString().split("T")[0]);
    const [customerName, setCustomerName] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [purchaseType, setPurchaseType] = useState("New");
    const [subTotal, setSubTotal] = useState(0);
    const [deduction, setDeduction] = useState(0);
    const [deductionRemarks, setDeductionRemarks] = useState("");
    const [totalWeight, setTotalWeight] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [openPreview, setOpenPreview] = useState(false);
    const [purchaseItems, setPurchaseItems] = useState([]);
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const [products, setProducts] = useState([{ category: "", productName: "", qty: 1, weight: "", lessweight: "", finalweight: "", stone: "", price: 0, amount: 0, productDetails: null },]);
    useEffect(() => {
        setPurchaseId(`PUR-${new Date().getFullYear()}-${Date.now().toString().slice(-4)}`);
    }, []);
    useEffect(() => {
        calculateTotals();
    }, [products, deduction]);
    useEffect(() => {
        fetchPurchaseData();
    }, []);
    const fetchPurchaseData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "product-purchase";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "productcategory";
            const response = await makeRequest("get", url);
            if (response) {
                setProductCategory(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const calculateTotals = () => {
        let weight = 0;
        let subtotal = 0;
        products.forEach((item) => {
            weight += Number(item.weight || 0);
            subtotal += Number(item.amount || 0);
        });
        setTotalWeight(weight);
        setSubTotal(subtotal);
        const finalAmount = Number(subtotal) - Number(deduction || 0);
        setTotalAmount(finalAmount);
    };
    const addProductRow = () => {
        setProducts([...products, { category: "", productName: "", qty: 1, weight: "", lessweight: "", finalweight: "", stone: "", price: "", amount: 0, },]);
    };
    const removeProductRow = (index) => {
        const updated = [...products];
        updated.splice(index, 1);
        setProducts(updated);
    };
    const handleProductChange = (index, field, value) => {
        const updated = [...products];
        updated[index][field] =
            field === "qty" || field === "weight" || field === "price" ? Number(value) : value;
        if (field === "category") {
            updated[index].productName = "";
            fetchProductsByCategory(value, index);
        }
        if (field === "productName") {
            const selectedProduct = productList[index]?.find(p => p.rfId === value);
            if (selectedProduct) {
                updated[index].weight =
                    Number(selectedProduct.weight || 0) > 0
                        ? Number(selectedProduct.weight)
                        : "";
                updated[index].price =
                    Number(selectedProduct.rate_per_gram || 0) > 0
                        ? Number(selectedProduct.rate_per_gram)
                        : "";
                updated[index].stone =
                    Number(selectedProduct.stone || 0) > 0
                        ? Number(selectedProduct.stone)
                        : "";
                updated[index].productDetails = selectedProduct;
            }
        }
        const qty = Number(updated[index].qty || 0);
        const weight = Number(updated[index].weight || 0);
        // const stone = Number(updated[index].stone || 0);
        const price = Number(updated[index].price || 0);
        const lessweight = Number(updated[index].lessweight || 0);
        const finalweight = weight - lessweight;
        updated[index].finalweight = finalweight;
        updated[index].amount = (finalweight * qty * price);
        setProducts(updated);
    };
    const handleSave = async () => {
        if (!customerName?.trim()) {
            setMessage("Supplier Name is required");
            setSnackbar(true);
            return;
        }
        if (!mobileNo?.trim()) {
            setMessage("Mobile Number is required");
            setSnackbar(true);
            return;
        }
        if (!purchaseDate) {
            setMessage("Purchase Date is required");
            setSnackbar(true);
            return;
        }
        if (!purchaseType) {
            setMessage("Purchase Type is required");
            setSnackbar(true);
            return;
        }
        if (!products || products.length === 0) {
            setMessage("Please add at least one product");
            setSnackbar(true);
            return;
        }
        for (const item of products) {
            if (!item.productName) {
                setMessage("Please select Product Name");
                setSnackbar(true);
                return;
            }
            if (!item.qty || Number(item.qty) <= 0) {
                setMessage("Please enter valid Quantity");
                setSnackbar(true);
                return;
            }
            if (!item.weight || Number(item.weight) <= 0) {
                setMessage("Please enter valid Weight");
                setSnackbar(true);
                return;
            }
            if (!item.price || Number(item.price) <= 0) {
                setMessage("Please enter valid Rate");
                setSnackbar(true);
                return;
            }
        }
        try {
            setLoading(true);
            const purchasePayload = {
                purchase_no: purchaseId,
                supplier_name: customerName,
                supplier_mobile: mobileNo,
                invoice_no: "",
                purchase_date: purchaseDate,
                purchase_type: purchaseType === "New" ? "NEW" : "OLD",
                total_amount: totalAmount,
                total_weight: totalWeight,
                payment_mode: "CASH",
                remarks: deductionRemarks,
                isActive: 0
            };
            const purchaseResponse = await makeRequest("post", webEndPoint + "product-purchase", purchasePayload);
            if (!purchaseResponse || !purchaseResponse.data) {
                throw new Error(
                    "Purchase creation failed"
                );
            }
            const purchase_id = purchaseResponse.data.rfId;
            for (const item of products) {
                const purchaseItemPayload = {
                    purchase_id,
                    product_id: item.productName,
                    qty: item.qty || 1,
                    gross_weight: item.weight || 0,
                    net_weight: item.weight || 0,
                    rate_per_gram: item.price || 0,
                    making_charges: item.productDetails?.making_charges_percentage || 0,
                    stone_price: 0,
                    less_weight: item.lessweight,
                    final_weight: item.finalweight,
                    total_amount: item.amount || 0
                };
                await makeRequest("post", webEndPoint + "product-purchase-item", purchaseItemPayload);
            }
            setMessage("Purchase Saved Successfully");
            setSnackbar(true);
            resetForm();
            setOpen(false);
            fetchPurchaseData();
        } catch (err) {
            console.error(err);
            setMessage(err?.response?.data?.message || err.message || "Purchase Save Failed");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const fetchProductsByCategory = async (categoryId, index) => {
        setLoading(true);
        try {
            let url = webEndPoint + "billing-products/category/" + categoryId;
            const response = await makeRequest("get", url);
            if (response) {
                setProductList(prev => ({ ...prev, [index]: response.data }));
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
            console.error(err);
        }
    };
    const resetForm = () => {
        setPurchaseId(`PUR-${new Date().getFullYear()}-${Date.now().toString().slice(-4)}`);
        setPurchaseDate(new Date().toISOString().split("T")[0]);
        setCustomerName("");
        setMobileNo("");
        setPurchaseType("New");
        setSubTotal(0);
        setDeduction(0);
        setDeductionRemarks("");
        setTotalWeight(0);
        setTotalAmount(0);
        setProductList({});
        setProducts([{ category: "", productName: "", qty: 1, weight: "", lessweight: "", finalweight: "", price: "", amount: 0, productDetails: null }]);
    };
    const openAdd = () => {
        setEditState(null);
        resetForm();
        setOpen(true);
    };
    const openEdit = (data) => {
        setEditState(data);
        // setCategory(data?.product_category_id);
        // setProductName(data?.product_name);
        setOpen(true);
    };
    const formatDateTime = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        return `${day}-${month}-${year}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
    };
    const formatDate = (date) => {
        return new Date(date).toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    };
    const handleViewPurchase = async (row) => {
        try {
            setLoading(true);
            setSelectedPurchase(row);
            const response = await makeRequest("get", webEndPoint + "product-purchase-item/purchase/" + row.rfId);
            if (response) {
                setPurchaseItems(response?.data || []);
                setOpenPreview(true);
            }
        } catch (err) {
            console.error(err);
            setMessage("Failed to load purchase items");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const downloadInvoice = async (purchaseId) => {
        try {
            setLoading(true);
            const response = await makeRequest("get", webEndPoint + "product-purchase/invoice/" + purchaseId);
            if (response?.url) {
                window.open(response.url, "_blank");
            }
        } catch (error) {
            console.error("Invoice download failed:", error);
            setMessage("Failed to load purchase items");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const filteredState = dataSource?.filter((d) =>
        d?.supplier_name?.toLowerCase().includes(search?.toLowerCase()) || d?.supplier_mobile?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Purchase No", "Date", "Customer", "Mobile", "Total Amount", "Action"];
    const rows = filteredState?.map((item, index) => [index + 1, item?.rfId, formatDate(item?.purchase_date), item?.supplier_name, item?.supplier_mobile, `₹ ${item.total_amount?.toLocaleString()}`,
    <Box>
        <Tooltip title="Preview">
            <IconButton color="info" onClick={() => handleViewPurchase(item)}><VisibilityIcon /></IconButton>
        </Tooltip>
        <Tooltip title="Print">
            <IconButton color="primary" onClick={() => downloadInvoice(item?.rfId)}><PrintIcon /></IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Purchase Bill</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search Supplier Name / Mobile Number" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd}>Create Purchase</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            {open && (
                <Box component="div" sx={{ position: "fixed", top: 60, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: "90%", height: "80%", display: "flex", overflow: "hidden", gap: 2 }}>
                        <Box sx={{ width: "25%", display: "flex", flexDirection: "column", gap: 2, height: "100%", overflowY: "auto", pr: 1, borderRight: "1px solid #e0e0e0" }}>
                            <Typography variant="h6" fontWeight={600}>Purchase Details</Typography>
                            <Divider />
                            <TextField label="Purchase ID" value={purchaseId} disabled fullWidth />
                            <TextField label="Purchase Date" type="date" value={purchaseDate}
                                onChange={(e) => setPurchaseDate(e.target.value)} InputLabelProps={{ shrink: true, }}
                                fullWidth />
                            <TextField select label="Purchase Type" value={purchaseType} onChange={(e) => setPurchaseType(e.target.value)} fullWidth>
                                <MenuItem value="New">New</MenuItem>
                                <MenuItem value="Old">Old</MenuItem>
                            </TextField>
                            <TextField label="Supplier / Customer Name" value={customerName} onChange={(e) => setCustomerName(e.target.value)} fullWidth />
                            <TextField label="Mobile Number" value={mobileNo} onChange={(e) => setMobileNo(e.target.value)} fullWidth />
                            <TextField label="Other Details" value={deductionRemarks} onChange={(e) => setDeductionRemarks(e.target.value)} multiline rows={4} fullWidth />
                            <TextField label="Sub Total" value={subTotal} disabled fullWidth />
                            <TextField label="Deduction" type="number" value={deduction} onChange={(e) => setDeduction(e.target.value)} fullWidth />
                            <TextField label="Total Weight" value={totalWeight} disabled fullWidth />
                            <TextField label="Total Amount" value={totalAmount} disabled fullWidth />
                        </Box>
                        <Box sx={{ width: "75%", height: "100%", overflowY: "auto", pl: 1, display: "flex", flexDirection: "column" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }}>
                                <Typography variant="h6" fontWeight={600}>Product Details</Typography>
                                <Button variant="contained" startIcon={<AddIcon />} onClick={addProductRow}>Add Product</Button>
                            </Box>
                            <Divider sx={{ mb: 2 }} />
                            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 0.8fr 0.8fr 0.8fr 1fr 1fr 1fr 60px", gap: 1, mb: 2, fontWeight: 600, }}>
                                <Typography>Category</Typography>
                                <Typography>Product</Typography>
                                <Typography>Qty</Typography>
                                <Typography>Weight(G)</Typography>
                                <Typography>Less Wt(G)</Typography>
                                <Typography>Final Wt(G)</Typography>
                                <Typography>Price(G)</Typography>
                                {/* <Typography>Stone Price</Typography> */}
                                <Typography>Amount</Typography>
                                <Typography></Typography>
                            </Box>
                            {products.map(
                                (item, index) => (
                                    <Box key={index} sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 0.8fr 0.8fr 0.8fr 1fr 1fr 1fr 60px", gap: 1, mb: 2, }}>
                                        <TextField select size="small" value={item.category}
                                            onChange={(e) => handleProductChange(index, "category", e.target.value)}>
                                            {productCategory?.map((cat) => (<MenuItem key={cat?.rfId} value={cat?.rfId}>{cat?.category_name}</MenuItem>))}
                                        </TextField>
                                        <TextField select size="small" value={item.productName}
                                            onChange={(e) => handleProductChange(index, "productName", e.target.value)}>
                                            {productList[index]?.map((item) => (<MenuItem key={item.rfId} value={item.rfId}>{item.product_name}</MenuItem>))}
                                        </TextField>
                                        <TextField size="small" type="number" value={item.qty}
                                            onChange={(e) => handleProductChange(index, "qty", e.target.value)} />
                                        <TextField size="small" type="number" value={item.weight || ""}
                                            onChange={(e) => handleProductChange(index, "weight", e.target.value)} />
                                        <TextField size="small" type="number" value={item.lessweight || ""}
                                            onChange={(e) => handleProductChange(index, "lessweight", e.target.value)} />
                                        <TextField size="small" type="number" value={item.finalweight || ""}
                                            onChange={(e) => handleProductChange(index, "finalweight", e.target.value)} />
                                        <TextField size="small" type="number" value={item.price || ""}
                                            onChange={(e) => handleProductChange(index, "price", e.target.value)} />
                                        {/* <TextField size="small" type="number" value={item.stone || ""}
                                            onChange={(e) => handleProductChange(index, "stone", e.target.value)} /> */}
                                        <TextField size="small" value={item.amount} disabled />
                                        <IconButton color="error" onClick={() => removeProductRow(index)}><DeleteIcon /></IconButton>
                                    </Box>
                                )
                            )}
                            <Box sx={{ position: "sticky", bottom: 0, backgroundColor: "#fff", borderTop: "1px solid #e0e0e0", pt: 2, mt: 2, display: "flex", justifyContent: "flex-end", gap: 2, zIndex: 10 }}>
                                <Button variant="outlined" color="error" size="large" onClick={() => setOpen(false)}>Close</Button>
                                <Button variant="contained" size="large" onClick={handleSave}>Save Purchase</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )}
            <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="lg" fullWidth>
                <DialogTitle sx={{ fontWeight: 600, fontSize: 24 }}>Purchase Details</DialogTitle>
                <DialogContent>
                    <Paper elevation={0} sx={{ p: 2, mb: 3, background: "#f8f8f8" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Purchase No</Typography>
                                <Typography>{selectedPurchase?.rfId}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Supplier Name</Typography>
                                <Typography>{selectedPurchase?.supplier_name}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Mobile Number</Typography>
                                <Typography>{selectedPurchase?.supplier_mobile}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Purchase Date</Typography>
                                <Typography>{formatDate(selectedPurchase?.purchase_date)}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Purchase Type</Typography>
                                <Typography>{selectedPurchase?.purchase_type}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Total Amount</Typography>
                                <Typography>₹ {Number(selectedPurchase?.total_amount || 0).toLocaleString()}</Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Typography fontWeight={600}>Other Deatils</Typography>
                    <Typography>{selectedPurchase?.remarks}</Typography><br />
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">#</TableCell>
                                    <TableCell>Product</TableCell>
                                    <TableCell align="center">Qty</TableCell>
                                    <TableCell align="right">Weight</TableCell>
                                    <TableCell align="right">Rate</TableCell>
                                    <TableCell align="right">Making</TableCell>
                                    <TableCell align="right">Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {purchaseItems?.map((item, index) => (
                                    <TableRow key={item?.rfId}>
                                        <TableCell align="center">{index + 1}</TableCell>
                                        <TableCell>{item?.product_name}</TableCell>
                                        <TableCell align="center">{item?.qty}</TableCell>
                                        <TableCell align="right">{Number(item?.net_weight).toFixed(3)}</TableCell>
                                        <TableCell align="right">₹ {Number(item?.rate_per_gram).toLocaleString()}</TableCell>
                                        <TableCell align="right">₹ {Number(item?.stone_price).toLocaleString()}</TableCell>
                                        <TableCell align="right">₹ {Number(item?.total_amount).toLocaleString()}</TableCell>
                                    </TableRow>
                                )
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => setOpenPreview(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}